export enum GuiSteps {
  CUSTOMIZE = 'customize',
  PRODUCT = 'product',
  REVIEW = 'review',
  ROSTER = 'roster',
  SPORT = 'sport',
  STYLE = 'style'
};